module.exports = __webpack_public_path__ + "static/media/t-2-q-9-2.702b757f.png";